export default "__VITE_ASSET__8319d38a__"